import { CustomSliderItem } from '@finn/ui-cosmic';
import { Slider } from '@finn/ui-modules';
import { parseToHtml } from '@finn/ui-utils';
import React from 'react';

import { BrandSliderItem } from '~/types/slider';
import BrandItem from '~/ui-elements/BrandItem';
import { convertCosmicSliderItemsToBrandItems } from '~/utils/brands';

interface IProps {
  title: string;
  items: CustomSliderItem[];
}

const CustomBrandSlider: React.FunctionComponent<IProps> = ({
  title,
  items,
}) => {
  const sliderItems: BrandSliderItem[] =
    convertCosmicSliderItemsToBrandItems(items);

  return (
    <div data-testid="custom-brandslider">
      {title && (
        <div className="container">
          <h2 className="mobile-t2-semibold md:web-t2-semibold mb-10">
            {parseToHtml(title)}
          </h2>
        </div>
      )}
      <Slider>
        {sliderItems.map((item) => (
          <BrandItem key={item.key} item={item} />
        ))}
      </Slider>
    </div>
  );
};

export default CustomBrandSlider;
